import AppContainer from "./framework/containers/AppContainer";

function App() {
  return <AppContainer />;
}

export default App;
